module.exports = __webpack_public_path__ + "img/title7.4d75fbea.png";